import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class ShouldExitFreespins extends Decision {
    public evaluate() {
        const record = GameState.getCurrentGame().getCurrentRecord() as FreespinRecord;

        return !record.beenPaid && record.isFreespinsComplete ? Exit.True : Exit.False;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/decisions/should-exit-freespins.ts